module.exports = __webpack_public_path__ + "static/background-ve-landing-6bb79b6d271a035e30c90d62b58c42c4.png";